import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AlertaElemento = (props) => {
  const {
    open,
    close,
    tipo,
    children
  } = props;
  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={close}>
      <Alert onClose={close} severity={tipo}>
        {children}
      </Alert>
    </Snackbar>
  );
};

export default AlertaElemento;
